import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import dayjs from 'dayjs';
import { MediaQuery as MQ } from '../../../media-query';
import TCODMobile from './mobile';
import TCODNonMobile from './non-mobile';

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        const date = props.date || dayjs().format('YYYY-MM-DD');

        this.state = { date: date };

        props.requireTCOD(date);
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.logged_in != this.props.logged_in) {
            if (nextProps.logged_in == false && this.props.base_url.match(/vip/)) { //user logs out on VIP page
                document.location.href = this.props.base_url.replace(/\/vip/, '');
                return false;
            } else if (
                nextProps.logged_in == true
                &&
                nextProps.user.subscriptions
                &&
                nextProps.user.subscriptions.vip
                &&
                !this.props.base_url.match(/vip/)
            ) { //user logs in on non-VIP page
                document.location.href = `/vip${this.props.base_url}`;
                return false;
            }
        }

        if (nextState.date != this.state.date) {
            return true;
        }

        if (nextProps.tcod != this.props.tcod) {
            return true;
        }

        return false;
    }

    render({ tcod, base_url }) {
        if (tcod) {
            const TCOD = MQ.isMobile() ? TCODMobile : TCODNonMobile;

            return (
                <daily-tarot-card base_url={base_url}>
                    <TCOD date={this.state.date} base_url={base_url} />
                </daily-tarot-card>
            );
        }

        return (<daily-tarot-card base_url={base_url} />);
    }
}

const mapStateToProps = (state) => ({
    tcod: state.tcod,
    logged_in: state.user && state.user.logged_in,
    user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
    requireTCOD: (date) => dispatch({ type: 'tcod:required', payload: date }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);